import React from 'react';
import { motion } from 'framer-motion';

const products = [
  {
    title: 'The Keepsake Trio',
    quantity: '3 Magnets',
    price: '$14.99',
    description: 'Perfect for a few favorite memories. High-quality materials with our signature artisan parlor finish.',
    featured: false
  },
  {
    title: 'The Collector’s Nine',
    quantity: '9 Magnets',
    price: '$34.99',
    description: 'Our most popular gift option. Offers a stunning professional grid for your fridge at a premium value.',
    featured: true
  },
  {
    title: 'The Grand Gallery',
    quantity: '24 Magnets',
    price: '$79.99',
    description: 'The ultimate high-end retail option for families wanting to curate an entire fridge gallery.',
    featured: false
  }
];

const ShopCollection = () => {
  const STORE_URL = "https://playful-toffee-fe84a2.netlify.app";

  return (
    <section id="shop" className="py-24 bg-parlor-cream-dark">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl text-parlor-green mb-4">Shop the Collection</h2>
          <div className="w-24 h-1 bg-parlor-gold mx-auto mb-6"></div>
          <p className="text-parlor-green/70 text-lg max-w-2xl mx-auto">
            Bring the parlor experience home. Curated sets shipped directly to your door, 
            crafted with the same artisan quality as our live events.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto items-center">
          {products.map((product, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.2, duration: 0.6 }}
              className={`relative p-8 md:p-10 flex flex-col items-center text-center transition-transform hover:-translate-y-2 ${
                product.featured 
                  ? 'bg-parlor-green text-parlor-cream shadow-2xl md:scale-105 z-10 border border-parlor-gold/30' 
                  : 'bg-white text-parlor-green shadow-xl border border-parlor-green/5'
              }`}
            >
              {product.featured && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-parlor-gold text-parlor-green text-xs font-bold uppercase tracking-widest py-1.5 px-6 rounded-full shadow-lg">
                  Most Loved
                </div>
              )}
              
              <h3 className={`font-serif text-2xl mb-2 ${product.featured ? 'text-parlor-gold' : ''}`}>
                {product.title}
              </h3>
              <p className={`text-sm tracking-widest uppercase mb-6 font-medium ${product.featured ? 'text-parlor-cream/60' : 'text-parlor-green/40'}`}>
                {product.quantity}
              </p>
              
              <div className="text-4xl font-light mb-6 flex items-start gap-1 justify-center">
                <span className="text-lg mt-1">$</span>
                {product.price.replace('$', '')}
              </div>

              <p className={`mb-8 flex-grow leading-relaxed ${product.featured ? 'text-parlor-cream/80' : 'text-parlor-green/70'}`}>
                {product.description}
              </p>

              <a 
                href={STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={`w-full py-4 uppercase tracking-[0.2em] text-xs font-bold transition-all duration-300 block text-center ${
                  product.featured 
                    ? 'bg-parlor-gold text-parlor-green hover:bg-parlor-cream shadow-xl' 
                    : 'border border-parlor-green text-parlor-green hover:bg-parlor-green hover:text-white'
                }`}
              >
                Add to Cart
              </a>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-parlor-green/40 text-sm italic">
            All magnets are 2" x 2" square with a premium soft-touch matte finish.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ShopCollection;